import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { StoreKey as EntityStoreKey } from 'web-app/react/entities/factory/constants';
import prefetch from 'signin-app/components/private-route/reducer';
import { entityReducer } from '../setup-entities';
import loginReducer from '../login/reducer';
import * as LoginActions from '../login/actions';
import globalEvent from '../global-event/reducer';
import institutionOverview from '../groups/reducer';
import child from '../child/reducer';
import childCheckIn from '../child/check-in/reducer';
import childCheckOut from '../child/check-out/reducer';
import employeeCheckIn from '../employee/check-in/reducer';
import employeeCheckOut from '../employee/check-out/reducer';
import childrenGroup from '../group/reducer';
import pin from '../pin/reducer';
import goHomeWith from '../go-home-with/reducer';
import modals from '../modals-container/reducer';
import account from '../account/reducer';
const reducersObj = {
    [EntityStoreKey]: entityReducer,
    globalEvent,
    institutionOverview,
    login: loginReducer,
    child,
    childCheckIn,
    childCheckOut,
    prefetch,
    employeeCheckIn,
    employeeCheckOut,
    childrenGroup,
    pin,
    goHomeWith,
    modals,
    account,
};
export const createRootReducer = history => {
    const appReducer = combineReducers({
        ...reducersObj,
        router: connectRouter(history),
    });
    const rootReducer = (state, action) => {
        // Resets entire Redux state on logOut
        if (action.type === LoginActions.logOutSuccess.type) {
            // Don't reset the router state,
            // otherwise some issues with browser history may appear
            const { router } = state;
            state = { router };
        }
        return appReducer(state, action);
    };
    return rootReducer;
};
export default createRootReducer;
